import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { discountsAPI } from '@/services/discountsApi';
import { queryKeys } from './queryKeys';

export function useAllDiscounts() {
  return useQuery({
    queryKey: queryKeys.discounts.everything(),
    queryFn: () => discountsAPI.getAllDiscounts(),
  });
}

export function useDiscounts(raceId?: any) {
  return useQuery({
    queryKey: queryKeys.discounts.all(raceId),
    queryFn: () => discountsAPI.getDiscounts(raceId),
    enabled: !!raceId,
  });
}

export function useCreateDiscount(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => discountsAPI.createDiscount(raceId, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.discounts.all(raceId) }),
  });
}

export function useUpdateDiscount(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => discountsAPI.updateDiscount(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.discounts.all(raceId) }),
  });
}

export function useDeleteDiscount(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => discountsAPI.deleteDiscount(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.discounts.all(raceId) }),
  });
}
